import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft, Loader2 } from "lucide-react";
import AppShell from "../components/AppShell";
import { Logo } from "../components/Logo";
import PhoneField, { DIAL_CODES } from "../components/PhoneField";
import { Field } from "./Login";
import { forgotPassword } from "../lib/api";

export default function ForgotPassword() {
  const nav = useNavigate();
  const [phone, setPhone] = useState("");
  const [dial, setDial] = useState(DIAL_CODES[0]);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (phone.length < 6) {
      toast.error("Enter a valid phone number");
      return;
    }
    setLoading(true);
    try {
      const fullPhone = `${dial.code}${phone}`;
      await forgotPassword({ phone: fullPhone, dial_code: dial.code });
      toast.success("Verification code sent", { description: `SMS sent to ${fullPhone}` });
      nav("/verify-otp", { state: { phone: fullPhone, purpose: "forgot" } });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AppShell>
      <div className="min-h-screen bg-white flex flex-col">
        <div className="screen flex-1 flex flex-col">
          <button
            onClick={() => nav(-1)}
            data-testid="forgot-back-btn"
            className="w-10 h-10 rounded-full border border-neutral-200 flex items-center justify-center hover:bg-neutral-50"
          >
            <ArrowLeft className="w-4 h-4" />
          </button>

          <div className="mt-8 flex justify-center">
            <Logo size="md" />
          </div>

          <div className="mt-8 text-center">
            <h1
              className="font-display font-bold text-[28px] tracking-tight text-black"
              data-testid="forgot-title"
            >
              Forgot password
            </h1>
          </div>

          <form onSubmit={submit} className="mt-10 space-y-5">
            <Field label="Mobile number">
              <PhoneField
                phone={phone}
                onPhoneChange={setPhone}
                dial={dial}
                onDialChange={setDial}
                testIdPhone="forgot-phone-input"
                testIdDial="forgot-dial-select"
              />
            </Field>
            <button
              type="submit"
              disabled={loading}
              data-testid="forgot-submit-btn"
              className="btn-brand mx-auto h-11 flex items-center justify-center text-[14px] min-w-[240px]"
            >
              {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Send verification code"}
            </button>
          </form>
        </div>
      </div>
    </AppShell>
  );
}
